import React, { useState, useEffect, useRef } from "react";
import { getProductlist, postHologramIssue } from "../../../services/apiService";
import { showSnackbar } from "../../../comopnents/snackbar";

const Warranty = () => {
  const [formData, setFormData] = useState({
    productid: "",
    batch: "",
    fromno: "",
    tono: "",
    date: "",
  });

  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    loadProducts();
  }, []);

  useEffect(() => {
    if (!search.trim()) {
      setFilteredProducts(products);
    } else {
      const data = products.filter((p) =>
        `${p.productid} ${p.subcategory} ${p.modelno}`
          .toLowerCase()
          .includes(search.toLowerCase()),
      );
      setFilteredProducts(data);
    }
  }, [search, products]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const loadProducts = async () => {
    setLoading(true);
    try {
      const res = await getProductlist(["SuperAdmin", "Warehouse"]);
      setProducts(res.Data || []);
      setFilteredProducts(res.Data || []);
     } catch (error) {
      console.error(error);
      showSnackbar("error", "Failed to load products");
     } finally {
      setLoading(false);
     }
  };
  const Hologram = async () => {
    setLoading(true);
    try {
      const res = await postHologramIssue(formData);
      if (res && res.status === 200) {
        showSnackbar("success", "Hologram issue submitted successfully");
      }
     } catch (error) {
      console.error(error);
      showSnackbar("error", "Failed to submit hologram issue");
     } finally {
      setLoading(false);
     }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "ProductList") {
      setSearch(value);
      setSelectedProduct(null);
      setShowDropdown(true);
    }
    setFormData({ ...formData, [name]: value });
  };

  const handleSelectProduct = (product) => {
    setSelectedProduct(product);
    setFormData((prev) => ({
      ...prev,
      productid: `${product.productid}`,
    }));
    setSearch("");
    setShowDropdown(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (Number(formData.fromno) > Number(formData.tono)) {
      showSnackbar("error", "Serial Number From should be less than Serial Number To");
      return;
    }

    console.log(formData);
    Hologram();
  };

  return (
    <div className="container mt-4">
      <div className="card p-4">
        <h3 className="mb-4">Hologram Issue</h3>

        <form onSubmit={handleSubmit}>
          <div className="mb-3" ref={wrapperRef} style={{ position: "relative" }}>
            <label className="form-label">Product List</label>
            <input
              type="text"
              className="form-control"
              name="ProductList"
              value={
                selectedProduct
                  ? `${selectedProduct.modelno} - ${selectedProduct.subcategory} `
                  : search
              }
              onChange={handleChange}
              onFocus={() => setShowDropdown(true)}
              placeholder="Search by product name, model or ID"
              required
              autoComplete="off"
            />
            {showDropdown && (
              <ul
                className="list-group"
                style={{
                  backgroundColor: "#f5f5f5",
                  position: "absolute",
                  zIndex: 1000,
                  width: "100%",
                  maxHeight: "200px",
                  overflowY: "auto",
                }}
              >
                {loading ? (
                  <li className="list-group-item">Loading...</li>
                ) : filteredProducts.length === 0 ? (
                  <li className="list-group-item">No products found</li>
                ) : (
                  filteredProducts.map((p) => (
                    <li
                      key={p.productid}
                      className="list-group-item list-group-item-action"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSelectProduct(p)}
                    >
                      {p.modelno} - {p.subcategory}
                    </li>
                  ))
                )}
              </ul>
            )}
          </div>

          {/* Batch No */}
          <div className="mb-3">
            <label className="form-label">Batch No</label>
            <input
              type="text"
              className="form-control"
              name="batch"
              value={formData.batch}
              onChange={handleChange}
              placeholder="Enter Batch No"
              required
            />
          </div>

          {/* Serial Number Range */}
          <div className="row mb-3">
            <div className="col-md-6">
              <label className="form-label">
                Serial Number From
              </label>
              <input
                type="number"
                className="form-control"
                name="fromno"
                value={formData.fromno}
                onChange={handleChange}
                placeholder="Ex: 10001"
                required
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">
                Serial Number To
              </label>
              <input
                type="number"
                className="form-control"
                name="tono"
                value={formData.tono}
                onChange={handleChange}
                placeholder="Ex: 19999"
                required
              />
            </div>
          </div>

          <small className="text-muted d-block mb-3">
            Example: 10001 - 19999
          </small>

          {/* Date */}
          <div className="mb-3">
            <label className="form-label">Date</label>
            <input
              type="date"
              className="form-control"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Warranty;
